import { useQuery } from "@tanstack/react-query";
import { getDashboard } from "services/apiDashboard";

export function useDashboard() {
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;

  const {
    isLoading,
    data: dashboard,
    error,
  } = useQuery({
    queryKey: ["dashboard", { id: user?.id }],
    queryFn: () => getDashboard({ id: user?.id }),
    enabled: !!user?.id,
  });

  return { isLoading, error, dashboard };
}
